import React from 'react';

class Masthead extends React.Component {
    render() {
        return (
            <header className="masthead text-center text-light d-flex">
                <div className="container my-auto">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <h1 className="text-uppercase">
                                <strong>Refreshing</strong> Software
                            </h1>
                            <hr/>
                        </div>
                        <div className="col-lg-8 mx-auto">
                            <p className="text-faded mb-5">
                                With years of agile software development experience in the government contracting space,
                                we are equipped to provide our clients with legacy and bleeding-edge insights to
                                help <strong>refresh</strong> and modernize complex software systems and build brand new
                                innovative solutions.
                            </p>
                            <a className="btn btn-primary btn-xl js-scroll-trigger" href="#about">
                                Who We Are
                            </a>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default Masthead;


// WEBPACK FOOTER //
// ./src/js/App/Masthead/Masthead.js